import { RoomMoveReportRequestModel } from '../api/models/RoomMoveReportRequestModel';
import { RoomMoveReportFormModel } from '../models';

export const dataFormToRequest = (data: RoomMoveReportFormModel): RoomMoveReportRequestModel => ({
  from: data.from,
  to: data.to,
  users: data.users,
  file_type: data.file_type,
});
